const ajax = CMS.axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  transitional: {
    silentJSONParsing: false,
  },
  responseType: 'json',
  transformResponse: [
    (data) => {
      // update CSRF tokens
      const res = JSON.parse(data) || null;
      if (typeof res === 'object' && res && typeof res.csrf_token !== 'undefined') {
        Array.from(document.querySelectorAll('input[name="csrf_token"]')).forEach(inputEl => {
          inputEl.value = res.csrf_token;
        });
      }
      return JSON.parse(data) || data;
    },
  ],
});

/**
 * Load content
 * 
 * @param {string} uri - Target page URI
 * @param {object} options - Optional settings
 * @param {boolean} [options.pushState=true] - trigger history.pushState() or don't
 * 
 * @returns {Promise}
 */
export const loadContent = (uri, options = {}) => {
  const _defaults = {
    pushState: true,
  };
  const opts = { ..._defaults, ...options };

  return new Promise((resolve, reject) => {
    ajax({
      method: 'get',
      url: uri,
    })
      .then(response => {
        if (opts.pushState) {
          history.pushState({}, '', uri);
        }
        resolve(response);
      })
      .catch(err => reject(err));
  });
};

export default ajax;
